<ml-mdm-command-spinner [commandProgress]="commandProgressInformation$"
                        [small]="true"
                        [direction]="'left'">
  <ml-mdm-command-spinner [commandProgress]="commandProgress$"
                          [small]="true"
                          [direction]="'left'">
    @if (class() !== 'dropdown-item') {
      <button [ngClass]="class()"
              [class.disabled]="(isEnabled | async) === false"
              (click)="disableLostMode()"
              [attr.title]="
          isSupervised()
            ? hasSupportedOS()
              ? ''
              : 'Only available in iOS 9.3 and later.'
            : 'Only available when device is supervised.'
        ">
        <ng-content></ng-content>
      </button>
    }
  </ml-mdm-command-spinner>
</ml-mdm-command-spinner>